import styled from "styled-components";
import { theme } from "Globals/Styles/AppTheme";
import { Box, Button } from "@material-ui/core";

export const StyledButton = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 12px;
    align-items: center;
    width: 300px;
    background-color: ${theme.palette.hightownBlue.light};
    color: ${theme.palette.common.white};
    &.Mui-disabled {
        color: ${theme.palette.common.white};
        opacity: 0.5;
    }
    :first-of-type {
        margin-right: 30px;
    }
    :hover {
        background-color: ${theme.palette.hightownBlue.light};
    }

    @media (max-width: 768px) {
        min-height: 48px;
        font-size: 16px;
    }
`;
